/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D image button
 */

import React from "react";
import PropTypes from "prop-types";

function ImageButton({
    disabled = false,
    src,
    width,
    height,
    onClickHandler,
    hoverColor = "#454545",
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <a-entity class="ImageButton" {...otherAttributes}>
            <a-plane
                position="0 0 0.002"
                color={hoverColor}
                width={width}
                height={height}
                visible={false}
                class={aframeClasses}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!disabled) onClickHandler(e);
                }}
                animation__mouseenter={`property: visible; to: true; startEvents: mouseenter; dur: 150; enabled: ${!disabled}`}
                animation__mouseleave={`property: visible; to: false; startEvents: mouseleave; dur: 150; enabled: ${!disabled}`}
            />
            <a-image
                width={(width / 5) * 4}
                height={(height / 5) * 4}
                position="0 0 0.004"
                src={src}
                opacity={disabled ? "0.5" : "1"}
            />
        </a-entity>
    );
}

ImageButton.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    height: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default ImageButton;
